import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=ea5e342e&scoped=true&"
import script from "./Avatar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=ea5e342e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5e342e",
  null
  
)

export default component.exports